import { ToastOptions } from "react-toastify";

export const errorConfig:ToastOptions ={
  autoClose:false,
};